// extracted by mini-css-extract-plugin
export default {"formContainer":"Fichas_formContainer__i0+Ag","addButton":"Fichas_addButton__MLEtZ"};